import React, {Fragment, useEffect, useState} from 'react';
import {BlueButton} from "../../button";
import Api from "../../../interface/api/visit";
import {OwlCarouselSlider3} from "../../slider";

interface EducationInfo {
    visitorInfoSeq : string
}

export function EducationButtonComponent({visitorInfo, educationCompleteHandler}) {

    const [ modal, setModal ] = useState<boolean>(false);

    return (
        <>
            <BlueButton onClickHandler={() => setModal(true)}
                        innerHTML={'미수료'}
                        type={'button'}
            />
            {
                modal && <Form visitorInfo={visitorInfo} educationCompleteHandler={educationCompleteHandler}/>
            }
        </>
    )
}

export function EducationComponent({visitorInfo, educationCompleteHandler}) {

    const [ step, setStep ] = useState(1)
    const [ blockNextCount, setBlockNextCount ] = useState(5);

    function nextStep() {
        setStep(step+1);
        setBlockNextCount(5);
    }

    function submit() {
        Api.visitorEducationClear(visitorInfo.seq).then( res =>
            educationCompleteHandler()
        )
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if(blockNextCount == 0) {
            } else {
                setBlockNextCount(blockNextCount-1);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [step, blockNextCount])

    return (
        <section className={'on'}>
            <div className="edu_slide_box">
                <div className="owl-carousel owl-theme" style={{display:"block"}}>
                    {<div style={{display : (step === 0 ? 'block' : 'none')}}><img src="/resource/common/images/s1.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 1 ? 'block' : 'none')}}><img src="/resource/common/images/s2.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 2 ? 'block' : 'none')}}><img src="/resource/common/images/s3.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 3 ? 'block' : 'none')}}><img src="/resource/common/images/s4.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 4 ? 'block' : 'none')}}><img src="/resource/common/images/s5.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 5 ? 'block' : 'none')}}><img src="/resource/common/images/s6.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 6 ? 'block' : 'none')}}><img src="/resource/common/images/s7.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 7 ? 'block' : 'none')}}><img src="/resource/common/images/s8.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 8 ? 'block' : 'none')}}><img src="/resource/common/images/s9.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 9 ? 'block' : 'none')}}><img src="/resource/common/images/s10.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 10 ? 'block' : 'none')}}><img src="/resource/common/images/s11.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 11 ? 'block' : 'none')}}><img src="/resource/common/images/s12.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 12 ? 'block' : 'none')}}><img src="/resource/common/images/s13.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 13 ? 'block' : 'none')}}><img src="/resource/common/images/s14.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 14 ? 'block' : 'none')}}><img src="/resource/common/images/s15.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 15 ? 'block' : 'none')}}><img src="/resource/common/images/s16.JPG" alt="" className="nv_img"/></div>}
                </div>
            </div>
            <div className="nv_btn_area" style={{marginTop:0}}>
                {
                    step === 15
                        ?<button id="eduComplatebtn"
                                 type="button"
                                 className="nv_btn_blue modal_close"
                                 onClick={submit}
                        >완료</button>
                        : (
                            blockNextCount === 0
                                ? <button id="eduComplatebtn"
                                          type="button"
                                          className="nv_btn_blue modal_close"
                                          onClick={nextStep}
                                >다음</button>
                                : <button id="eduComplatebtn"
                                          type="button"
                                          className="nv_btn_blue modal_close"
                                >{blockNextCount}초..</button>
                        )
                }
            </div>
        </section>
    )
}

export function EducationComponentForSld({visitorInfo, educationCompleteHandler}) {

    const [ step, setStep ] = useState(0)
    const [ blockNextCount, setBlockNextCount ] = useState(5);

    function nextStep() {
        setStep(step+1);
        setBlockNextCount(5);
    }

    function submit() {
        Api.visitorEducationClear(visitorInfo.seq).then( res =>
            educationCompleteHandler()
        )
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if(blockNextCount == 0) {
                // setBlockNextCount(10);
            } else {
                setBlockNextCount(blockNextCount-1);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [step, blockNextCount])

    return (
        <section className={'on'}>
            <div className="edu_slide_box">
                <div className="owl-carousel owl-theme" style={{display:"block"}}>
                    {<div style={{display : (step === 0 ? 'block' : 'none')}}><img src="/resource/common/images/sld_s1.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 1 ? 'block' : 'none')}}><img src="/resource/common/images/sld_s2.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 2 ? 'block' : 'none')}}><img src="/resource/common/images/sld_s3.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 3 ? 'block' : 'none')}}><img src="/resource/common/images/sld_s4.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 4 ? 'block' : 'none')}}><img src="/resource/common/images/sld_s5.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 5 ? 'block' : 'none')}}><img src="/resource/common/images/sld_s6.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 6 ? 'block' : 'none')}}><img src="/resource/common/images/sld_s7.JPG" alt="" className="nv_img"/></div>}
                    {<div style={{display : (step === 7 ? 'block' : 'none')}}><img src="/resource/common/images/sld_s8.JPG" alt="" className="nv_img"/></div>}
                </div>
            </div>
            <div className="nv_btn_area" style={{marginTop:0}}>
                {
                    step === 7
                        ?<button id="eduComplatebtn"
                                 type="button"
                                 className="nv_btn_blue modal_close"
                                 onClick={submit}
                        >완료</button>
                        : (
                            blockNextCount === 0
                                ? <button id="eduComplatebtn"
                                          type="button"
                                          className="nv_btn_blue modal_close"
                                          onClick={nextStep}
                                >다음</button>
                                : <button id="eduComplatebtn"
                                          type="button"
                                          className="nv_btn_blue modal_close"
                                >{blockNextCount}초..</button>
                        )
                }
            </div>
        </section>
    )
}

function Form({visitorInfo, educationCompleteHandler}) {
    const [ step, setStep ] = useState(0)

    function nextStep() {
        setStep(step+1);
    }

    function submit() {
        Api.visitorEducationClear(visitorInfo.seq).then( res =>
            educationCompleteHandler()
        )
    }
    return (
        <div className="modal edu_modal modal2 on">
            <div className="modal_con">
                <div className="modal_btn_wrap">
                    <button type="button" className="modal_close">x</button>
                </div>
                <div className="tit">
                    <h2>방문교육</h2>
                </div>
                <div className="edu_slide_box">
                    <div className="owl-carousel owl-theme" style={{display:"block"}}>
                        {step === 0 && <div><img src="/resource/common/images/s1.JPG" alt="" className="nv_img"/></div>}
                        {step === 1 && <div><img src="/resource/common/images/s2.JPG" alt="" className="nv_img"/></div>}
                        {step === 2 && <div><img src="/resource/common/images/s3.JPG" alt="" className="nv_img"/></div>}
                        {step === 3 && <div><img src="/resource/common/images/s4.JPG" alt="" className="nv_img"/></div>}
                        {step === 4 && <div><img src="/resource/common/images/s5.JPG" alt="" className="nv_img"/></div>}
                        {step === 5 && <div><img src="/resource/common/images/s6.JPG" alt="" className="nv_img"/></div>}
                        {step === 6 && <div><img src="/resource/common/images/s7.JPG" alt="" className="nv_img"/></div>}
                        {step === 7 && <div><img src="/resource/common/images/s8.JPG" alt="" className="nv_img"/></div>}
                        {step === 8 && <div><img src="/resource/common/images/s9.JPG" alt="" className="nv_img"/></div>}
                        {step === 9 && <div><img src="/resource/common/images/s10.JPG" alt="" className="nv_img"/></div>}
                        {step === 10 && <div><img src="/resource/common/images/s11.JPG" alt="" className="nv_img"/></div>}
                        {step === 11 && <div><img src="/resource/common/images/s12.JPG" alt="" className="nv_img"/></div>}
                        {step === 12 && <div><img src="/resource/common/images/s13.JPG" alt="" className="nv_img"/></div>}
                        {step === 13 && <div><img src="/resource/common/images/s14.JPG" alt="" className="nv_img"/></div>}
                        {step === 14 && <div><img src="/resource/common/images/s15.JPG" alt="" className="nv_img"/></div>}
                        {step === 15 && <div><img src="/resource/common/images/s16.JPG" alt="" className="nv_img"/></div>}
                    </div>
                </div>
                <div className="nv_btn_area">
                    {
                        step === 15
                            ?<button id="eduComplatebtn"
                                     type="button"
                                     className="nv_btn_blue modal_close"
                                     onClick={submit}
                            >완료</button>
                            : <button id="eduComplatebtn"
                                      type="button"
                                      className="nv_btn_blue modal_close"
                                      onClick={nextStep}
                            >다음</button>
                    }
                </div>
            </div>
        </div>
    )
}